export default __webpack_public_path__ + "static/media/exclusive-maxi.c03eafc5.jpg";